<template>
  <div class="column">
    <div class="column has-status-bar--left has-status-bar--draft">
      <div class="title is-6 is-uppercase">Livraison</div>
    </div>
    <div class="columns">
      <div class="column is-4 is-paddingless-right">
        <label class="label">Date de Pré-Réception</label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-square is-static is-border is-min-width-0">
              <span class="icon"><i class="fas fa-calendar-alt"></i></span>
            </a>
          </div>
          <div class="control is-expanded">
            <flat-pickr type="date" class="input" v-model="adv.livraison.date_pre_reception"
                        :disabled="!isAdmin || isSectorManager"
                        :config="dateConfig" @on-change="commitAdv">
            </flat-pickr>
          </div>
          <div class="control" v-if="isAdmin || isSectorManager">
            <a class="button is-square is-grey is-inverted is-border is-min-width-0"
              @click="adv.livraison.date_pre_reception = null">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- <div class="column is-4">
        <v-input id="numero_ar" name="numero_ar" @input="numeroARInput"
                :model="adv.livraison.numero_ar"
                label="Numéro AR(Pour convoc)" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Numéro AR(Pour convoc)">
        </v-input>
      </div> -->
    </div>
    <div class="columns">
      <div class="column is-4 is-paddingless-right" v-if="isAdmin || isSectorManager">
        <v-input id="livraison_prevu" name="livraison_prevu" @input="livraisonPrevuInput"
                :model="adv.livraison.livraison_prevu"
                label="Période de livraison prévue" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Période de livraison prévue">
        </v-input>
      </div>
      <div class="column is-4">
        <label class="label">Date de livraison client</label>
        <div class="field has-addons">
          <div class="control">
            <a class="button is-square is-static is-border is-min-width-0">
              <span class="icon"><i class="fas fa-calendar-alt"></i></span>
            </a>
          </div>
          <div class="control is-expanded">
            <flat-pickr type="date" class="input" :disabled="!isAdmin || isSectorManager"
                        v-model="adv.contrat_de_reservation.date_livraison_client"
                        :config="dateConfig" @on-change="commitAdv">
            </flat-pickr>
          </div>
          <div class="control" v-if="isAdmin || isSectorManager">
            <a class="button is-square is-grey is-inverted is-border is-min-width-0"
              @click="adv.contrat_de_reservation.date_livraison_client = null">
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="columns">
      <div class="column is-4">
        <v-input id="numero_pdl" name="numero_pdl" @input="numeroPdlInput"
                :model="adv.livraison.numero_pdl"
                label="Numéro PDL" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Numéro PDL">
        </v-input>
      </div>
      <div class="column is-4">
        <v-input id="numero_pce" name="numero_pce" @input="numeroPceInput"
                :model="adv.livraison.numero_pce"
                label="Numéro PCE" :errors-bag="errors" data-vv-value-path="val"
                data-vv-as="Numéro PCE">
        </v-input>
      </div>
    </div> -->
    <div class="column is-10 is-padding-top-xsmall" v-if="isAdmin || isSectorManager">
      <table class="table is-std is-form full-width is-margin-top-small is-last-fixed-small ">
        <thead>
        <tr class="is-light is-size-7 is-uppercase">
          <th>Liste des élements fournis au clients</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(element, idx) in elements" :key="idx">
          <td>
            <input :id="idx + '-element'" type="text" v-model="elements[idx]" @input="commitAdv" class="input">
            <i class="fal fa-pencil-alt has-text-grey"></i>
          </td>
          <td>
            <button class="button is-circle is-small" @click="removeElement(idx)">
              <i class="fal fa-times"></i>
            </button>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>
            <button class="button is-small is-light is-border is-rounded" @click="addElement">
              <span class="icon has-text-grey"><i class="fas fa-plus-circle"></i></span><span class="is-transform-none">Ajouter un élément</span>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <!-- <div v-if="!showCommentField" class="columns">
      <div class="column is-narrow">
        <a @click="showCommentField = !showCommentField" class="has-text-reserve is-size-6">
          <span class="icon is-small">
          <i class="fal fa-sticky-note"></i></span>&nbsp;Ajouter un commentaire
        </a>
      </div>
    </div> -->
    <div v-if="showCommentField && (isAdmin || isSectorManager)" class="columns">
      <div class="column is-10">
        <label for="" class="label">Commentaire</label>
        <div class="field" @mouseover="displayToolbar = true" @mouseleave="displayToolbar = false">
          <div class="control">
            <wysiwyg-editor :model="adv.livraison.comment" placeholder="" 
                            @change="val => editComment(val, adv.livraison, 'comment')"
                            :class="{'editr--hide-toolbar':!displayToolbar}" :light='true'
                            class="editr--bottom-toolbar editr--height-small content has-bg-white" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { AdvMx } from '@/mixins'
  import { isNil } from 'lodash'

  export default {
    name: 'Livraison',
    mixins: [AdvMx],
    computed: {
      currentComment () {
        return this.adv.livraison.comment
      },
      elements () {
        if (!isNil(this.livraison.elements)) {
          return this.livraison.elements
        } else return []
      }
    },
    methods: {
      addElement () {
        if (!Array.isArray(this.livraison.elements)) this.livraison.elements = []
        this.livraison.elements.push('')
        this.$emit('commit', this.adv, false)
      },
      removeElement (index) {
        this.livraison.elements.splice(index, 1)
        this.$emit('commit', this.adv, false)
      },
      numeroARInput (val) {
        this.livraison.numero_ar = val
        this.$emit('commit', this.adv, false)
      },
      livraisonPrevuInput (val) {
        this.livraison.livraison_prevu = val
        this.$emit('commit', this.adv, false)
      },
      numeroPdlInput (val) {
        this.livraison.numero_pdl = val
        this.$emit('commit', this.adv, false)
      },
      numeroPceInput (val) {
        this.livraison.numero_pce = val
        this.$emit('commit', this.adv, false)
      },
      newReminder () {
        this.$store.commit('setQuickview', {mode: 'NEW_REMINDER'})
      },
      newRdv () {
        this.$router.push({name: 'CalendarCreate'})
      }
    }
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/adv/FeuilleDeRoute/Livraison.vue